<template>
  <div id="app">
    <a-layout>
      <HYHeader :menu="menu" :selectedKey="currentRouteKey" />
      <HYQQLinks :qq="contact.sale.qq" custom :mystyle="QQSideLinksStyle">
        <svg
          t="1618235496009"
          class="icon"
          viewBox="0 0 1024 1024"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          p-id="2014"
          width="24"
          height="24"
        >
          <path
            d="M68.399765 590.615655c-37.073602 90.765025-43.465533 176.418105-14.062849 191.757941 20.45478 11.505876 53.692423-14.061849 84.374094-60.084355 11.504876 51.135451 42.186547 95.87897 84.373094 132.952572-44.743519 16.619821-74.146204 44.743519-74.146204 75.42519 0 51.135451 79.259149 93.321998 176.418105 93.321997 88.208052 0 161.07627-33.237643 175.138119-77.982162h20.45478C535.009753 990.751357 607.87897 1023.989 696.087023 1023.989c98.436943 0 176.418105-40.908561 176.418104-93.321997 0-30.68167-29.402684-58.806368-74.146203-75.42519 42.186547-37.073602 72.868217-81.817121 84.374094-132.952572 30.68067 46.022506 62.640327 71.589231 84.373093 60.084355 30.68167-15.339835 24.289739-102.270901-14.061849-191.757941-29.403684-70.311245-69.033258-122.725682-99.714929-134.230558 0-3.835959 1.278986-8.949904 1.278987-14.062849 0-26.845712-7.669918-52.413437-20.454781-72.868217v-5.112945c0-12.783863-2.555973-24.289739-7.669917-34.516629C818.813704 145.736434 701.200968 0 510.722014 0 320.24206 0 202.630323 145.736434 194.959406 329.824457c-5.112945 10.22689-7.669918 21.732767-7.669918 34.516629v5.112945c-12.783863 20.45478-20.45478 46.022506-20.45478 72.869217v14.061849c-28.123698 11.504876-69.032258 62.640327-98.434943 134.230558z"
            fill="#ffffff"
            p-id="2015"
          ></path>
        </svg>
        <span style="text-align: center">在线咨询</span>
      </HYQQLinks>
      <main class="main-page">
        <router-view />
      </main>
      <HYFooter />
      <a-back-top />
    </a-layout>
  </div>
</template>

<script>
import menus from '@/menu'
import appConf from '@/config/config'
import HYHeader from '@/components/Header'
import HYFooter from '@/components/Footer'
import HYQQLinks from '@/components/QQLinks'
const { contact } = appConf

export default {
  components: {
    HYHeader,
    HYFooter,
    HYQQLinks,
  },
  data() {
    return {
      menu: [...menus],
      contact,
      QQSideLinksStyle: `
      position:fixed;
      right:0;
      top:50%;
      z-index: 99999;
      transform:translateY(-50%);
      background:rgb(0, 122, 204);
      color: #fff;
      width: 30px;
      border-radius: 5px;
      padding: 5px 4px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      font-szie: 20px;
      text-decoration: none;
      `,
    }
  },
  computed: {
    currentRouteKey() {
      let key = ''
      this.menu.some((e) => {
        if (e.name === this.$route.name) {
          key = String(e.name)
          return
        }
      })
      return key
    },
  },
}
</script>
<style lang="css">
main.main-page {
  min-height: 100vh;
}
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  overflow: hidden;
}
</style>
